import React from 'react'
import { RequestAccessStyled } from './styled/request-access'

const RequestAccess = ({ children }) => {
  return <RequestAccessStyled>{children}</RequestAccessStyled>
}

export default RequestAccess
